/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:03]
Permissions to update outside the main branch: [false]
*/

import { Button } from '@finbeat/react-toolkit';
import { CreditProduct } from 'models/api/creditProduct';
import { TariffGroupCreditProduct } from 'models/api/tariffGroup';
import { useCreditProductsList } from 'providers/CreditProductsProvider';
import { Trans } from 'react-i18next';

type TariffGroupCreditProductAddButtonProps = {
    tariffGroupId: number;
    handleTariffGroupCreditProductAdd: (
        newTariffGroupCreditProduct: TariffGroupCreditProduct
    ) => void;
    disabled: boolean;
};

const TariffGroupCreditProductAddButton = ({
    tariffGroupId,
    handleTariffGroupCreditProductAdd,
    disabled,
}: TariffGroupCreditProductAddButtonProps) => {
    const { tariffGroupCreditProductProps, isTariffGroupCreditProductPropsFetching } =
        useCreditProductsList();

    if (isTariffGroupCreditProductPropsFetching) {
        return <></>;
    }

    const emptyRecord: TariffGroupCreditProduct = {
        tariffGroupId: tariffGroupId,
        creditProduct: {} as CreditProduct,
        creditProductId: 0,
        isBase: false,
        minSum: 0,
        maxSum: 0,
        props: [...tariffGroupCreditProductProps] || [],
        isDeleted: false,
    };

    const handleAddNewRecord = () => {
        handleTariffGroupCreditProductAdd(emptyRecord);
    };

    return (
        <Button disabled={disabled} className="float-end" onClick={handleAddNewRecord}>
            <Trans i18nKey="BackOfficeAdd" />
        </Button>
    );
};
export default TariffGroupCreditProductAddButton;
